import type { Locale, LocaleMeta } from '../types/locale';
import { countryLocales, locales } from '../data/locales';

const prefixed: Locale[] = ['de', 'fr', 'pl', 'ar'];

// The language is set only by the address: /de/…, /fr/… — a plain link always opens in English
export function localeFromPath(pathname: string): Locale {
  const first = pathname.split('/')[1]?.toLowerCase() ?? '';
  return (prefixed as string[]).includes(first) ? (first as Locale) : 'en';
}

export function stripLocale(pathname: string): string {
  const locale = localeFromPath(pathname);
  if (locale === 'en') return pathname || '/';
  const rest = pathname.slice(locale.length + 1);
  return rest.startsWith('/') ? rest : `/${rest}`;
}

export function localizedPath(pathname: string, locale: Locale): string {
  const bare = stripLocale(pathname);
  if (locale === 'en') return bare;
  return bare === '/' ? `/${locale}` : `/${locale}${bare}`;
}

export function localeMeta(locale: Locale): LocaleMeta {
  return locales.find((l) => l.code === locale) ?? locales[0];
}

export function localeForCountry(countryCode: string | null | undefined): Locale | null {
  if (!countryCode) return null;
  return countryLocales[countryCode.toUpperCase()] ?? null;
}
